import styled from 'styled-components';

import Button from '@components/Button/next';

export const StyledPriceRangeFilter = styled.div`
  .listing-filters-accommodation-input,
  .listing-filters-accommodation-input input {
    border: none;
    outline: none;
    width: auto;
    min-width: 1em;
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.matterHorn};
    background-color: transparent;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    .listing-filters-accommodation-input {
      width: 100%;
      height: 100%;
    }
  }
`;

export const PriceRangeInputLabel = styled.span`
  display: block;
  width: fit-content;
  height: 15px;
  margin: 0 0 3px;
  opacity: 0.5;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.palette.darkGrey};
  transition: all 0.5s;
`;

export const PriceRangeInputBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;

  input::placeholder {
    color: ${({ theme }) => theme.palette.NL500};
    font-size: 16px;
    font-weight: 400;
  }
`;

export const PriceRangeInputWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.inputBorderColor};
  background-color: ${({ theme }) => theme.palette.NL10};
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PriceRangeWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
  grid-template-rows: 44px;
  grid-auto-rows: 44px;
  grid-gap: 10px;
  padding: 20px 0 0 0;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0;
    background-color: ${({ theme }) => theme.palette.white};
  }
`;

export const PriceRangeButton = styled(Button)`
  width: 100%;
  margin: 10px 0 0;
  color: ${({ theme }) => theme.palette.R600};
  font-weight: 900;
  font-size: 14px;
  border: solid 1 px ${({ theme }) => theme.palette.R600};
  border-radius: 8px;

  &:disabled {
    opacity: 0.6;
  }
`;

export const Title = styled.h3`
  font-weight: bold;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.eclipse};
`;

PriceRangeButton.defaultProps = {
  outline: true,
};

export const NoneCollapsableStyledPriceRangeFilter = styled.div`
  padding: 12px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  border-radius: 8px;

  .listing-filters-accommodation-input,
  .listing-filters-accommodation-input input {
    border: none;
    outline: none;
    width: auto;
    min-width: 1em;
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.matterHorn};
    background-color: transparent;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    .listing-filters-accommodation-input {
      width: 100%;
      height: 100%;
    }
  }
`;
